import React, { useState } from 'react';

interface ButtonSwitchProps {
  labels: string[]
  handleChange: (index: number) => void,
  selected?: number
}

const ButtonSwitch: React.FC<ButtonSwitchProps> = ({ labels, handleChange, selected }) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  const handleButtonClick = (index: number) => {
    setSelectedIndex(index);
    handleChange(index)
  };

  return (
    <div className={`tw-flex tw-rounded tw-bg-[#7676801F] tw-p-0.5 tw-w-full tw-justify-between`}>
      {labels.map((label, index) => (
        <React.Fragment key={index}>
          {/* {index !== 0 && (
            <span className={`tw-self-center tw-w-[1px] tw-h-[12px] tw-mb-2.5 tw-text-[#dedee2] tw-transition-opacity tw-duration-300 tw-ease-in-out tw-opacity-50`}>|</span>
          )} */}
          <button
            className={`${
              index === (selected ?? selectedIndex)
                ? 'tw-bg-white tw-text-xs tw-font-normal tw-text-gray-900 tw-shadow-md'
                : 'tw-bg-transparent tw-text-xs tw-font-normal tw-text-gray-500'
            } tw-px-3.5 tw-py-1 tw-rounded-l tw-rounded tw-transition-all tw-duration-300 tw-ease-in-out`}
            onClick={() => handleButtonClick(index)}
          >
            {label}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
};

export default ButtonSwitch;
